const GOOGLE_SHEET_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSerMz6guhcdA6ExUsEsE6Flf4zjcqTHfbzwuxT9Zc2-lN_v3w/viewform?usp=sharing&ouid=101590982662870849452";

export function useExternalLink() {
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const openExternalLink = (url, target = "_blank") => {
    if (typeof window === "undefined") return;
    if (!url || !isValidUrl(url)) {
      console.warn("[useExternalLink] Invalid URL:", url);
      return;
    }

    window.open(url, target, "noopener,noreferrer");
  };

  const openGoogleSheet = () => {
    openExternalLink(GOOGLE_SHEET_LINK);
  };

  return {
    openExternalLink,
    openGoogleSheet,
  };
}
